<script>
export default {
  props: {
    cartIsOpen: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      items: [],
      errors: [],
      submitting: false,
      open: this.cartIsOpen,
    }
  },

  methods: {
    add (item) {
      this.submitting = true
      this.$inertia.post("/cart", item)
        .then(() => {
          if (!Object.keys(this.$page.props.errors).length) {
            this.open = true
          }
          this.submitting = false
        })
    },

    remove (item) {
      this.submitting = true
      this.$inertia.delete(`/cart/${item.product.id}`)
        .then(() => {
          this.submitting = false
        })
    },

    increment (item) {
      this.submitting = true
      this.$inertia.post(`/cart/${item.product.id}/quantity`, { ...item, quantity: item.quantity + 1 })
        .then(() => {
          this.submitting = false
        })
    },

    decrement (item) {
      this.submitting = true
      this.$inertia.post(`/cart/${item.product.id}/quantity`, { ...item, quantity: item.quantity - 1 })
        .then(() => {
          this.submitting = false
        })
    },

    openCart () {
      this.open = true
    },

    closeCart () {
      this.open = false
    }
  },

  render () {
    return this.$scopedSlots.default({
      items: this.items,
      count: this.count,
      add: this.add,
      remove: this.remove,
      increment: this.increment,
      decrement: this.decrement,
      open: this.openCart,
      close: this.closeCart,
      cartIsOpen: this.open,
      submitting: this.submitting,
      errors: this.errors
    })
  },

  computed: {
    count () {
      return this.items.length
    }
  }
}
</script>
